/** README 
 *  封装：业务层级的请求对象
 *        >>> 基于 SystemHttp 类
 *        >>> 对项目提供：不同业务场景下的请求对象
 * 
 *  注意：维护规范
 *        >>> index.js 中，尽量避免强业务相关的代码，仅针对不同场景，创建请求对象的实例
 *        >>> 其他 **.js 脚本：
 *            >>> 模块化封装：公共请求方法
 *            >>> 文件命名：能凸显模块的作用
 * 
 * 
 *  待完善：
 *        1- 
 * 
 * 
 */


import SystemHttp from "./systemHttp.js";







/** ======【对外提供一些特定场景的 axios-PureHttp 实例】============================================================================= */
export const httpBus = new SystemHttp("/cloud/");
// export const httpCloud = new SystemHttp("/cloud/");










